// extracted by mini-css-extract-plugin
export default {"cls1":"gN9fKbBIgj_9AuGbbsYL","cls2":"xNFs2vLltscynNhYANDY gN9fKbBIgj_9AuGbbsYL"};